module.exports = __webpack_public_path__ + "static/media/wave-right-up.7ddad285.svg";